/** Browser history for Explore views (map / ranking / compare / home / account / guide). */

export const EXPLORE_HISTORY_SOURCE = "schoolcatch-explore";

const VIEW_PARAM = "view";
const SCHOOL_PARAM = "school";
const PAGES = new Set(["map", "home", "ranking", "compare", "account"]);

export function snapshotFromView({ page = "map", journeySchoolId = null } = {}) {
  const id = Number(journeySchoolId);
  if (Number.isFinite(id) && id > 0) {
    return { source: EXPLORE_HISTORY_SOURCE, page: "map", journeySchoolId: id };
  }
  const nextPage = PAGES.has(page) ? page : "map";
  return { source: EXPLORE_HISTORY_SOURCE, page: nextPage, journeySchoolId: null };
}

export function sameExploreSnapshot(a, b) {
  if (!a || !b) return false;
  return (
    a.page === b.page &&
    Number(a.journeySchoolId || 0) === Number(b.journeySchoolId || 0)
  );
}

export function buildExploreUrl(snapshot) {
  const url = new URL(window.location.href);
  const snap = snapshotFromView(snapshot);
  if (snap.journeySchoolId) {
    url.searchParams.set(VIEW_PARAM, "guide");
    url.searchParams.set(SCHOOL_PARAM, String(snap.journeySchoolId));
  } else if (snap.page && snap.page !== "map") {
    url.searchParams.set(VIEW_PARAM, snap.page);
    url.searchParams.delete(SCHOOL_PARAM);
  } else {
    url.searchParams.delete(VIEW_PARAM);
    url.searchParams.delete(SCHOOL_PARAM);
  }
  return `${url.pathname}${url.search}${url.hash}`;
}

export function readExploreHistoryFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const view = String(params.get(VIEW_PARAM) || "").toLowerCase();
  const schoolId = Number(params.get(SCHOOL_PARAM));

  if (view === "guide" && Number.isFinite(schoolId) && schoolId > 0) {
    return snapshotFromView({ page: "map", journeySchoolId: schoolId });
  }
  if (PAGES.has(view)) {
    return snapshotFromView({ page: view, journeySchoolId: null });
  }
  return null;
}

export function readExploreHistoryFromState(state) {
  if (!state || state.source !== EXPLORE_HISTORY_SOURCE) return null;
  return snapshotFromView(state);
}

export function writeExploreHistory(snapshot, mode = "push") {
  const snap = snapshotFromView(snapshot);
  const url = buildExploreUrl(snap);
  if (mode === "replace") {
    window.history.replaceState(snap, "", url);
  } else {
    window.history.pushState(snap, "", url);
  }
  return snap;
}

export function currentExploreHistoryOwnsGuide() {
  const snap = readExploreHistoryFromState(window.history.state);
  return Boolean(snap?.journeySchoolId);
}
